import { render } from "./contact-table.vue?vue&type=template&id=05d4acc4"
import script from "./contact-table.vue?vue&type=script&lang=js"
export * from "./contact-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__